export default "__VITE_ASSET__2GYj9aO2__"